import { defaultRcsPreviewCompilationContext } from '../defaults';

/** Context shape used for preview compile; may contain full snapshot fields. */
export type RcsCompilationContextForPreview = Record<string, unknown>;

/**
 * Derives the compilation context from the snapshot JSON string in the editor.
 * Used for preview compile requests and for "preview required" comparison.
 * If the parsed JSON has a compilationContext property, that is returned; otherwise the root object.
 * On parse error, empty string, or invalid shape, returns the default preview context.
 */
export function getCompilationContextFromSnapshotJson(snapshotJson: string): RcsCompilationContextForPreview {
  const trimmed = snapshotJson?.trim();
  if (!trimmed) {
    return { ...defaultRcsPreviewCompilationContext };
  }

  let parsed: unknown;
  try {
    parsed = JSON.parse(trimmed);
  } catch {
    return { ...defaultRcsPreviewCompilationContext };
  }

  if (parsed === null || typeof parsed !== 'object' || Array.isArray(parsed)) {
    return { ...defaultRcsPreviewCompilationContext };
  }

  const obj = parsed as Record<string, unknown>;
  if (obj.compilationContext !== undefined && obj.compilationContext !== null) {
    const ctx = obj.compilationContext;
    if (typeof ctx === 'object' && !Array.isArray(ctx)) {
      return { ...(ctx as Record<string, unknown>) };
    }
    return { ...defaultRcsPreviewCompilationContext };
  }

  return { ...obj };
}
